import React from "react";
const axios = require("axios").default;

class Stats extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      total: 0,
    };

    this.runTotalCheck = this.runTotalCheck.bind(this);
    this.getTotalConsumed = this.getTotalConsumed.bind(this);

    this.interval = null;
  }

  componentDidMount() {
    this.getTotalConsumed();
    this.runTotalCheck();
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  runTotalCheck() {
    this.interval = setInterval(
      function () {
        this.getTotalConsumed();
      }.bind(this),
      5000
    );
  }

  async getTotalConsumed() {
    try {
      let result = await axios.get("https://fivemapi.offsdev.com/sumol");
      if (result && result.status === 200 && result.data.success) {
        this.setState({ total: result.data.total });
      }
    } catch (error) {
      //
    }
  }

  render() {
    return (
      <section id="stats">
        <div className="container position-relative">
          <div className="consumed">
            <div className="information">
              <div className="textbox">
                <div className="title">CONSUMIDAS</div>
                <div className="amount">{this.state.total}</div>
              </div>

              <div className="drinkcan animate__animated animate__fadeInLeft">
                <img src="./images/lata.png" alt="lata"></img>
              </div>

              <svg className="bubble01" viewBox="0 0 278 410" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M86.5327 84.7571C83.2294 77.9334 90.7614 59.9622 113.995 45.6377C130.528 35.4445 157.119 23.75 162.795 36.037C168.891 49.2341 150.544 48.5131 133.726 71.6872C116.908 94.8614 93.5802 99.3152 86.5327 84.7571Z"
                  fill="#71BB2A"
                />
                <path
                  d="M212.683 41.3946C205.392 31.3235 223.912 21.224 236.937 14.174C248.425 7.95597 261.054 0.131256 269.546 7.4862C279.729 16.3052 260.5 30.6386 246.545 37.7867C234.526 43.9434 219.323 50.5683 212.683 41.3946Z"
                  fill="#71BB2A"
                />
                <path
                  d="M153.579 212.393C148.421 212.378 149.324 204.162 149.977 198.397C150.553 193.312 150.848 187.492 155.36 186.498C160.77 185.305 161.148 194.725 160.31 200.809C159.588 206.048 158.277 212.407 153.579 212.393Z"
                  fill="#71BB2A"
                />
                <path
                  d="M86.2462 306.477C91.2293 305.245 92.4974 312.584 93.3686 317.74C94.1369 322.287 95.3676 327.402 91.271 329.353C86.3591 331.693 83.5409 323.618 82.7657 318.143C82.0979 313.427 81.7071 307.598 86.2462 306.477Z"
                  fill="#71BB2A"
                />
                <path
                  d="M135.639 21.8927C133.72 16.0054 143.995 14.0368 151.213 12.6773C157.58 11.4783 164.729 9.69124 167.626 14.4733C171.101 20.2073 159.85 24.076 152.178 25.3403C145.569 26.4293 137.387 27.2553 135.639 21.8927Z"
                  fill="#71BB2A"
                />
                <path
                  d="M161.804 122.151C159.706 121.164 158.634 119.773 158.161 118.135C157.665 116.422 157.785 114.288 158.408 111.828C159.658 106.888 162.751 101.29 165.43 96.4836C165.77 95.874 166.107 95.2628 166.442 94.654C168.469 90.9719 170.45 87.3752 172.829 84.7272C174.193 83.2093 175.619 82.0891 177.163 81.4621C178.682 80.8457 180.4 80.6707 182.44 81.1721C184.803 81.7532 186.147 83.0185 186.881 84.6955C187.652 86.4577 187.807 88.8149 187.419 91.5785C186.645 97.0995 183.802 103.594 180.911 108.463C178.376 112.733 175.468 117.166 172.169 120.022C170.533 121.438 168.871 122.402 167.183 122.803C165.526 123.195 163.752 123.068 161.804 122.151Z"
                  stroke="#71BB2A"
                  strokeWidth="3"
                />
                <path
                  d="M113.073 232.244C96.4238 227.803 104.272 204.545 109.843 188.239C114.756 173.857 119.203 157.089 134.372 158.026C152.561 159.149 148.126 187.022 141.767 204.1C136.289 218.809 128.239 236.29 113.073 232.244Z"
                  fill="#71BB2A"
                />
                <path
                  d="M10.4211 259.535C6.04714 256.148 5.13444 241.959 15.6665 225.055C23.161 213.027 36.7404 196.752 44.4387 202.938C52.7073 209.583 40.4838 215.068 37.0174 235.672C33.5509 256.276 19.753 266.76 10.4211 259.535Z"
                  fill="#71BB2A"
                />
                <path
                  d="M195.617 332.823C191.056 335.954 177.266 332.491 164.385 317.301C155.219 306.491 143.867 288.591 152.108 283.149C160.96 277.304 162.452 290.619 181.014 300.211C199.575 309.802 205.346 326.142 195.617 332.823Z"
                  fill="#71BB2A"
                />
                <path
                  d="M117.041 123.308C120.985 128.995 113.067 143.352 104.106 151.505C96.2022 158.695 74.0226 167.571 69.3618 154.764C65.1641 143.231 80.1163 139.27 89.8248 130.909C98.1868 123.708 113.098 117.621 117.041 123.308Z"
                  fill="#71BB2A"
                />
                <path
                  d="M44.7112 364.041C35.6516 365.359 38.4226 378.421 41.038 387.195C43.9858 397.083 52.1658 411.151 59.9668 405.628C66.9926 400.654 61.0572 390.307 57.5334 381.528C54.3789 373.67 53.0912 362.822 44.7112 364.041Z"
                  fill="#71BB2A"
                />
                <path
                  d="M17.8392 128.232C17.389 127.731 17.0754 126.834 17.1007 125.411C17.1256 124.012 17.478 122.302 18.1196 120.43C19.4024 116.688 21.7451 112.577 24.3775 109.496C26.6242 106.868 31.267 103.566 35.8397 101.972C38.1205 101.177 40.2367 100.859 41.9509 101.146C43.5876 101.42 44.8912 102.241 45.7444 103.902C46.5666 105.503 46.6624 106.893 46.3304 108.177C45.9857 109.51 45.1471 110.85 43.8905 112.237C42.637 113.621 41.0451 114.967 39.3047 116.33C38.5914 116.889 37.8266 117.47 37.0555 118.056C36.0178 118.844 34.9686 119.641 34.0183 120.404C31.015 122.814 27.3641 125.549 24.1052 127.237C22.4671 128.085 21.0385 128.609 19.9068 128.749C18.8009 128.885 18.2048 128.639 17.8392 128.232Z"
                  stroke="#71BB2A"
                  strokeWidth="3"
                />
                <path
                  d="M65.8833 265.026C64.5686 265.355 63.5702 265.125 62.736 264.577C61.8466 263.992 61.0356 262.967 60.3322 261.542C58.9208 258.681 58.1821 254.7 57.8733 251.253C57.5329 247.455 57.8849 242.753 59.1908 239.278C59.8434 237.541 60.6839 236.246 61.6621 235.477C62.5802 234.756 63.707 234.425 65.2156 234.75C66.619 235.053 67.5067 235.691 68.1176 236.527C68.7582 237.405 69.1677 238.604 69.3932 240.12C69.6179 241.632 69.6446 243.346 69.603 245.178C69.5862 245.92 69.5565 246.715 69.5264 247.519C69.4858 248.606 69.4446 249.709 69.4337 250.721C69.4212 251.886 69.4629 253.112 69.5032 254.299C69.5196 254.783 69.5358 255.26 69.5481 255.724C69.5914 257.368 69.5874 258.89 69.4111 260.236C69.2344 261.585 68.898 262.639 68.3622 263.412C67.855 264.145 67.1058 264.72 65.8833 265.026Z"
                  stroke="#71BB2A"
                  strokeWidth="3"
                />
              </svg>

              <svg className="bubble02" viewBox="0 0 249 215" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M128.434 58.0069C131.685 60.1297 127.749 64.9488 124.975 68.3229C122.528 71.2989 119.957 74.8535 116.7 73.6331C112.794 72.1698 116.415 66.0652 119.436 62.5662C122.039 59.5525 125.472 56.0732 128.434 58.0069Z"
                  fill="#71BB2A"
                />
                <path
                  d="M246.099 56.4591C247.182 60.9933 239.352 61.8479 233.853 62.4305C229.002 62.9444 223.529 63.8522 221.645 60.088C219.385 55.5745 228.063 53.3533 233.897 52.8695C238.921 52.4529 245.112 52.3289 246.099 56.4591Z"
                  fill="#71BB2A"
                />
                <path
                  d="M35.0837 134.034C36.3499 135.085 36.8158 136.202 36.8492 137.373C36.8848 138.622 36.4285 140.087 35.5264 141.735C33.7125 145.05 30.4422 148.512 27.5748 151.52C27.2091 151.904 26.8468 152.288 26.4868 152.67C24.3126 154.974 22.2253 157.187 20.0309 158.643C18.78 159.473 17.5833 159.992 16.4127 160.148C15.2699 160.301 14.0629 160.121 12.7367 159.407C11.2208 158.591 10.5534 157.512 10.3532 156.27C10.1383 154.936 10.4436 153.263 11.2338 151.352C12.8118 147.537 16.07 143.378 19.0759 140.392C21.729 137.756 24.6454 135.112 27.5288 133.681C28.9541 132.974 30.2869 132.607 31.5149 132.632C32.7103 132.656 33.8993 133.051 35.0837 134.034Z"
                  stroke="#71BB2A"
                  strokeWidth="3"
                />
                <path
                  d="M162.151 62.0637C170.848 71.6899 156.362 83.1649 146.163 91.1819C137.167 98.2529 127.488 107.022 118.291 100.215C107.263 92.0538 121.484 76.2657 132.497 68.0844C141.983 61.0377 154.23 53.2951 162.151 62.0637Z"
                  fill="#71BB2A"
                />
                <path
                  d="M79.433 157.883C77.6294 152.995 86.1046 144.022 94.1719 139.766C101.287 136.013 119.126 133.721 120.112 143.933C120.999 153.131 109.354 153.202 100.703 157.468C93.2517 161.143 81.2365 162.772 79.433 157.883Z"
                  fill="#71BB2A"
                />
              </svg>

              <svg className="bubble03" viewBox="0 0 279 411" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M192.419 325.42C195.738 332.277 188.169 350.338 164.82 364.733C148.204 374.977 121.482 386.73 115.777 374.382C109.651 361.119 128.089 361.844 144.991 338.555C161.893 315.265 185.336 310.789 192.419 325.42Z"
                  fill="#71BB2A"
                />
                <path
                  d="M65.6417 368.998C72.9683 379.119 54.3564 389.269 41.2669 396.354C29.7219 402.603 17.0296 410.466 8.49543 403.075C-1.73762 394.212 17.587 379.807 31.6108 372.624C43.6896 366.436 58.9679 359.778 65.6417 368.998Z"
                  fill="#71BB2A"
                />
                <path
                  d="M131.86 189.076C136.772 190.734 133.294 198.276 130.835 203.564C128.665 208.227 126.53 213.679 121.913 213.19C116.377 212.603 119.018 203.504 121.754 197.973C124.112 193.209 127.387 187.566 131.86 189.076Z"
                  fill="#71BB2A"
                />
                <path
                  d="M188.615 102.581C183.486 102.037 184.804 94.6684 185.748 89.4995C186.581 84.9405 187.172 79.686 191.711 79.2473C197.153 78.7212 197.048 87.315 195.903 92.7535C194.917 97.4377 193.288 103.078 188.615 102.581Z"
                  fill="#71BB2A"
                />
                <path
                  d="M143.069 388.597C144.997 394.513 134.671 396.492 127.417 397.858C121.018 399.063 113.834 400.859 110.922 396.053C107.431 390.29 118.737 386.402 126.448 385.132C133.089 384.037 141.312 383.207 143.069 388.597Z"
                  fill="#71BB2A"
                />
                <path
                  d="M116.777 287.833C118.887 288.826 119.965 290.225 120.442 291.873C120.94 293.598 120.819 295.743 120.193 298.216C118.936 303.182 115.828 308.808 113.135 313.639C112.794 314.251 112.456 314.865 112.119 315.477C110.081 319.177 108.091 322.793 105.699 325.455C104.328 326.981 102.894 328.107 101.34 328.738C99.8125 329.358 98.0841 329.534 96.033 329.03C93.6556 328.445 92.3035 327.172 91.5648 325.485C90.7889 323.712 90.6338 321.341 91.0235 318.563C91.8019 313.014 94.6594 306.485 97.5646 301.593C100.113 297.301 103.035 292.845 106.352 289.974C107.996 288.551 109.667 287.581 111.366 287.178C113.033 286.783 114.818 286.911 116.777 287.833Z"
                  stroke="#71BB2A"
                  strokeWidth="3"
                />
                <path
                  d="M176.793 183.06C191.247 192.598 176.356 212.265 165.851 226.032C156.586 238.175 147.005 252.74 132.845 247.014C115.867 240.148 128.975 214.995 140.477 200.744C150.384 188.469 163.626 174.373 176.793 183.06Z"
                  fill="#71BB2A"
                />
                <path
                  d="M268.909 149.773C273.304 153.177 274.222 167.436 263.637 184.424C256.105 196.513 242.459 212.868 234.722 206.651C226.412 199.974 238.697 194.461 242.18 173.755C245.664 153.048 259.53 142.512 268.909 149.773Z"
                  fill="#71BB2A"
                />
                <path
                  d="M161.759 286.677C157.795 280.961 165.753 266.534 174.758 258.34C182.701 251.114 204.991 242.195 209.675 255.064C213.894 266.655 198.867 270.636 189.11 279.038C180.707 286.275 165.722 292.392 161.759 286.677Z"
                  fill="#71BB2A"
                />
                <path
                  d="M225.753 45.1553C234.676 47.3986 237.101 34.2008 238.029 25.0473C239.075 14.7307 236.86 -1.47268 227.497 0.672752C219.065 2.60502 220.619 14.4918 220.533 23.9978C220.456 32.5077 217.499 43.0803 225.753 45.1553Z"
                  fill="#71BB2A"
                />
                <path
                  d="M261.459 281.724C261.914 282.229 262.229 283.133 262.203 284.564C262.178 285.971 261.824 287.69 261.179 289.572C259.89 293.333 257.535 297.466 254.889 300.562C252.63 303.205 247.963 306.524 243.366 308.126C241.074 308.926 238.946 309.245 237.221 308.957C235.574 308.681 234.262 307.855 233.403 306.183C232.576 304.573 232.48 303.174 232.814 301.882C233.161 300.54 234.004 299.192 235.268 297.798C236.528 296.407 238.128 295.054 239.877 293.684C240.594 293.122 241.363 292.538 242.138 291.95C243.18 291.157 244.235 290.357 245.19 289.59C248.208 287.168 251.877 284.419 255.153 282.723C256.8 281.87 258.236 281.342 259.375 281.202C260.488 281.064 261.09 281.312 261.459 281.724Z"
                  stroke="#71BB2A"
                  strokeWidth="3"
                />
                <path
                  d="M218.872 144.556C220.224 144.733 221.075 145.316 221.655 146.138C222.272 147.014 222.653 148.272 222.786 149.864C223.053 153.061 222.278 157.056 221.298 160.393C220.218 164.071 218.158 168.34 215.656 171.11C214.406 172.494 213.143 173.397 211.943 173.756C210.817 174.093 209.639 173.988 208.346 173.127C207.144 172.326 206.547 171.402 206.284 170.393C206.007 169.335 206.066 168.061 206.413 166.56C206.76 165.063 207.366 163.45 208.079 161.752C208.368 161.063 208.689 160.331 209.013 159.59C209.451 158.589 209.895 157.573 210.278 156.631C210.718 155.546 211.131 154.384 211.53 153.26C211.693 152.801 211.853 152.349 212.013 151.91C212.577 150.357 213.141 148.934 213.802 147.74C214.464 146.543 215.167 145.681 215.954 145.154C216.7 144.654 217.614 144.392 218.872 144.556Z"
                  stroke="#71BB2A"
                  strokeWidth="3"
                />
              </svg>

              <svg className="bubble04" viewBox="0 0 133 122" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M95.008 109.672C91.3288 108.43 93.9342 102.779 95.7765 98.8186C97.4015 95.3252 99.0011 91.2405 102.46 91.6073C106.607 92.0471 104.629 98.8633 102.579 103.007C100.813 106.576 98.3594 110.803 95.008 109.672Z"
                  fill="#71BB2A"
                />
                <path
                  d="M1.70789 105.262C-0.475042 101.143 6.89222 98.357 12.0708 96.4173C16.6384 94.7065 21.7103 92.4585 24.4765 95.6316C27.7933 99.4363 19.9474 103.758 14.4199 105.685C9.65895 107.346 3.69631 109.014 1.70789 105.262Z"
                  fill="#71BB2A"
                />
                <path
                  d="M105.418 35.0225C103.929 34.3215 103.199 33.3564 102.874 32.2314C102.527 31.0307 102.602 29.4985 103.063 27.6768C103.99 24.0138 106.291 19.8442 108.314 16.214C108.572 15.7511 108.827 15.2886 109.08 14.8291C110.609 12.0538 112.076 9.3895 113.837 7.43042C114.84 6.31371 115.869 5.51215 116.963 5.068C118.032 4.63441 119.245 4.50661 120.708 4.86618C122.38 5.27718 123.296 6.15473 123.8 7.30741C124.342 8.54533 124.465 10.2417 124.178 12.2893C123.604 16.378 121.49 21.2194 119.327 24.8629C117.417 28.0786 115.255 31.3679 112.821 33.4744C111.618 34.5157 110.42 35.2041 109.224 35.4874C108.061 35.7632 106.811 35.6782 105.418 35.0225Z"
                  stroke="#71BB2A"
                  strokeWidth="3"
                />
                <path
                  d="M61.3476 114.178C50.5196 107.034 61.6747 92.2997 69.5442 81.9863C76.4851 72.89 83.6627 61.9785 94.2702 66.2681C106.989 71.4116 97.1698 90.255 88.553 100.931C81.1313 110.127 71.2109 120.687 61.3476 114.178Z"
                  fill="#71BB2A"
                />
                <path
                  d="M72.61 36.5554C75.579 40.8371 69.618 51.6455 62.8715 57.7834C56.9212 63.1971 40.2231 69.8788 36.7141 60.2375C33.5538 51.5542 44.8108 48.5723 52.1199 42.2779C58.4153 36.8565 69.641 32.2736 72.61 36.5554Z"
                  fill="#71BB2A"
                />
              </svg>
            </div>
          </div>

          <div className="sumoldrop">
            <div className="drop">
              <div className="maracuja">
                <img src="./images/maracuja.png" alt="maracuja-sumol"></img>
              </div>
              <img className="dropimg" src="./images/drop.png" alt="sumol drop"></img>
              <div className="sumolmaracuja animate__animated animate__fadeInRight">
                <img src="./images/sumolmaracuja.png" alt="Sumol maracujá"></img>
              </div>
            </div>
          </div>

          <div className="maracujablur">
            <img src="./images/maracujablur.png" alt="Maracuja Blur"></img>
          </div>
        </div>
      </section>
    );
  }
}

export default Stats;
